import clsx from 'clsx'

import type { QuizQuestionAlternative } from '../../model/types'

type QuizThisOrThatProps = {
  alternatives: QuizQuestionAlternative[]
  value: string | null
  disabled?: boolean
  onChange: (alternativeUid: string) => void
}

export function QuizThisOrThat({
  alternatives,
  value,
  disabled,
  onChange
}: QuizThisOrThatProps) {
  return (
    <div className="grid grid-cols-2 gap-3">
      {alternatives.map(alternative => (
        <button
          key={alternative.uid}
          type="button"
          disabled={disabled}
          onClick={() => onChange(alternative.uid)}
          className={clsx(
            'flex h-24 items-center justify-center rounded-xl border p-3 text-center text-sm font-bold transition-colors',
            value === alternative.uid
              ? 'border-[var(--color-brand)] bg-[var(--color-brand)]/10'
              : 'border-gray-200 bg-white'
          )}
        >
          {alternative.name}
        </button>
      ))}
    </div>
  )
}
